<script setup lang="tsx">
import { computed } from 'vue'

const props = defineProps<{ daysToDueDate: number | null }>()

const isOverdue = computed(() => props.daysToDueDate !== null && props.daysToDueDate < 0)

const cls = computed(() => {
	const d = props.daysToDueDate
	if (d === null) return ''
	if (d < 0) return 'text-danger fw-bold'
	if (d <= 1) return 'text-danger fw-bold'
	if (d > 1 && d < 3) return 'text-danger fw-bold'
	if (d >= 3 && d < 6) return 'text-warning'
	return 'text-success'
})
</script>

<template>
	<span v-if="daysToDueDate !== null" :class="cls">
		<template v-if="isOverdue">
			{{ $t('date.overdue') }}
		</template>
		<template v-else>{{ daysToDueDate }} {{ $t('date.day', 2) }}</template>
	</span>
</template>
